import { Alert } from "react-bootstrap"
import ClipLoader from "react-spinners/ClipLoader"
import "./LoadingIndicator.css"

const getMessage = (message) => {
    if(message === undefined) {
        return "Loading data..."
    } else return message
}

const LoadingIndicator = (props) => {
    const message = getMessage(props.message)
    return (<div className="loadingIndicator">
        <Alert variant="primary">
            <div className="alertContent">
                <div>
                    <Alert.Heading>Please wait</Alert.Heading>
                    {message}
            </div>
                <ClipLoader/>
            </div>
        </Alert>
    </div>)
}

export default LoadingIndicator
